// removed by extract-text-webpack-plugin
module.exports = {"languageWrapper":"aXP2iTbvzjOq8ezD5G0mD","locations":"JCqZUVwGygghRtjX9WuwD","languages":"WGkEPBreiyYV0iJPiRjLM","russian":"hq-3pQEpLSskpoYGSfjuN","onmap":"_29FIsAQlaR8qQgFrdOSc-q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageSelection/LanguageSelection.scss
// module id = 1612
// module chunks = 0